import { render, staticRenderFns } from "./VideoLandmarksPlayer.vue?vue&type=template&id=c0e3b7b6&scoped=true"
import script from "./VideoLandmarksPlayer.vue?vue&type=script&lang=js"
export * from "./VideoLandmarksPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideoLandmarksPlayer.vue?vue&type=style&index=0&id=c0e3b7b6&prod&scoped=true&lang=css"
import style1 from "./VideoLandmarksPlayer.vue?vue&type=style&index=1&id=c0e3b7b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e3b7b6",
  null
  
)

export default component.exports